import React, { useCallback, useEffect, useState } from 'react'
import context from '@/context'
import { openAlertDialog, openErrorDialog } from '@/utils/dialogHelpers'
import { useLocalization } from '@/hooks/localization'
import RsaKeyPolicyForm from '@/components/administration/rsaKeyPolicy/RsaKeyPolicyForm'

function RsaKeyPolicy () {
  const [ rsaKeyPolicy, setRsaKeyPolicy ] = useState()
  const [updating, setUpdating] = useState(false)

  const { localize } = useLocalization()

  useEffect(() => {
    context.api.rsaKeyPolicyService.get()
      .then(x => { setRsaKeyPolicy({ ...x }) })
      .catch(openErrorDialog)
  }, [])

  const onSave = useCallback((input) => {
    setUpdating(true)
    context.api.rsaKeyPolicyService.save(input)
      .then(() => {
        openAlertDialog({ title: 'Common.Success', text: 'Security.PasswordPolicySaved' })
        setUpdating(false)
      })
      .catch(openErrorDialog)
  }, [])

  if (!rsaKeyPolicy) return ''

  return <RsaKeyPolicyForm
    localize={localize}
    fetching={!rsaKeyPolicy}
    updating={updating}
    forcingPasswordChange={updating}
    save={onSave}
    {...rsaKeyPolicy} />
}

export default RsaKeyPolicy



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/passwordPolicy/RsaKeyPolicy.js